module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/babel-loader/lib/index.js??ref--9!./index.js"));
	});
}